'use client'

import { useState } from 'react'
import Image from 'next/image'
import Lightbox from './Lightbox'
import './home-v2.css'

// Same photo set the previous Life At GHL Prime section used, served from
// /public. Split into two rows that scroll in opposite directions.
const FILES = [
  'DSC00064 (1).jpg',
  'DSC00071 (1).jpg', 'DSC00072 (1).jpg', 'DSC00111 (1).jpg',
  'DSC00353 (1).jpg',
  'Image (2).jpg', 'Image (3).jpg', 'Image (4).jpg', 'Image (7).jpg',
  'Image (8).jpg', 'Image (9).jpg', 'Image (11).jpg', 'Image (12).jpg',
  'Image (13).jpg', 'Image (14).jpg', 'Image (17).jpg', 'Image (18).jpg',
  'Image (20).jpg', 'Image (21).jpg', 'Image (22).jpg', 'Image (23).jpg',
  'Image (24).jpg', 'Image (40).jpg',
]

const SHOTS = FILES.map((file, i) => ({
  id: `life-${i}`,
  src: `/life-at-images/${file.replace(/ /g, '%20')}`,
}))

const half = Math.ceil(SHOTS.length / 2)
const ROWS = [SHOTS.slice(0, half), SHOTS.slice(half)]

export default function LifeAtGhlV2() {
  const [viewing, setViewing] = useState(null)

  return (
    <section className="hv2 hv2-section is-white">
      <div className="hv2-inner">
        <div className="hv2-head centered" data-rv="0.4">
          <span className="hv2-eyebrow">Team culture</span>
          <h2>Life at <span className="hv2-hl">GHL Prime.</span></h2>
          <p>
            The team behind the builds works from one office, on the same hours as your
            clients. We ship together instead of passing tickets around.
          </p>
        </div>
      </div>

      <div className="hv2-life-rows" data-rv="0.2" style={{ '--rv-y': '0px', '--rv-ease': 'ease' }}>
        {ROWS.map((row, i) => {
          // A loop copy must span the row, or the -50% keyframe leaves a gap
          // at the end. Repeat the row until it is long enough, then duplicate.
          const copies = Math.max(1, Math.ceil(8 / row.length))
          const oneCopy = Array.from({ length: copies }, () => row).flat()
          const track = [...oneCopy, ...oneCopy]
          return (
            <div className={`hv2-life-row${i % 2 ? ' is-reverse' : ''}`} key={i}>
              <div className="hv2-life-track" style={{ animationDuration: `${52 + i * 10}s` }}>
                {track.map((shot, j) => (
                  <button
                    type="button"
                    className="hv2-life-shot"
                    key={`${shot.id}-${j}`}
                    onClick={() => setViewing(SHOTS.indexOf(shot))}
                    aria-label="View photo full screen"
                  >
                    {/* These source photos come straight off a phone (several
                        run 5-11MB at 6000px+), decoded and thrown at a
                        272x204 tile -- that decode cost, repeated across
                        every tile in the marquee, was the actual lag, not
                        the CSS animation. next/image asks Next's image
                        endpoint for a tile-sized, compressed copy instead of
                        shipping the original. The lightbox still opens the
                        full-resolution file directly. */}
                    <Image
                      src={shot.src}
                      alt="GHL Prime team at work"
                      fill
                      sizes="(max-width: 760px) 208px, 272px"
                      quality={60}
                    />
                  </button>
                ))}
              </div>
            </div>
          )
        })}
      </div>

      <Lightbox
        images={SHOTS.map((s) => ({ src: s.src, alt: 'Life at GHL Prime' }))}
        index={viewing}
        onClose={() => setViewing(null)}
        onStep={setViewing}
      />
    </section>
  )
}
